import React from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * Component to conditionally render children based on user permissions.
 * Usage:
 * <PermissionGuard permission="inv.delete">
 *   <button>Delete Product</button>
 * </PermissionGuard>
 */
const PermissionGuard = ({ permission, children, fallback = null }) => {
    const { hasPermission } = useAuth();

    if (hasPermission(permission)) {
        return <>{children}</>;
    }

    return fallback;
};

export default PermissionGuard;
